// Static artworks data — works without backend.
// Same payload as backend used to return from GET /api/artworks.
export const ARTWORKS = [
  {
    id: "krolowa",
    slug: "krolowa",
    title: "Królowa",
    image: "https://gonzaga.pl/img/krolowa.jpg",
    category_pl: "Malarstwo sztalugowe",
    category_en: "Easel Painting",
    medium_pl: "Olej na płótnie / Minimalizm",
    medium_en: "Oil on canvas / Minimalism",
    year: 2023,
    description_pl:
      "Praca utrzymana w duchu królewskiej powściągliwości — czerń, biel i jeden gest.",
    description_en:
      "A piece carried by royal restraint — black, white and a single gesture.",
  },
  {
    id: "new-chapter",
    slug: "new-chapter",
    title: "New Chapter",
    image: "https://gonzaga.pl/img/8.jpg",
    category_pl: "Malarstwo sztalugowe",
    category_en: "Easel Painting",
    medium_pl: "Olej na płótnie / Minimalizm",
    medium_en: "Oil on canvas / Minimalism",
    year: 2024,
    description_pl:
      "Otwarcie. Cisza, która zapowiada nowy rozdział w pracowni.",
    description_en:
      "An opening. The silence that announces a new chapter in the studio.",
  },
  {
    id: "riviera-palace",
    slug: "riviera-palace",
    title: "Riviera Palace",
    image: "https://gonzaga.pl/img/9.jpg",
    category_pl: "Kolekcja Prywatna",
    category_en: "Private Collection",
    medium_pl: "Olej na płótnie / Minimalizm",
    medium_en: "Oil on canvas / Minimalism",
    year: 2023,
    description_pl: "Dzieło stworzone z myślą o rezydencji na Lazurowym Wybrzeżu.",
    description_en: "A work created with the French Riviera residence in mind.",
  },
  {
    id: "kompozycja-ii",
    slug: "kompozycja-ii",
    title: "Kompozycja II",
    image: "https://gonzaga.pl/img/2.jpg",
    category_pl: "Malarstwo sztalugowe",
    category_en: "Easel Painting",
    medium_pl: "Olej na płótnie / Minimalizm",
    medium_en: "Oil on canvas / Minimalism",
    year: 2022,
  },
  {
    id: "kompozycja-xiv",
    slug: "kompozycja-xiv",
    title: "Kompozycja XIV",
    image: "https://gonzaga.pl/img/14.jpg",
    category_pl: "Kolekcja Prywatna",
    category_en: "Private Collection",
    medium_pl: "Olej na płótnie / Minimalizm",
    medium_en: "Oil on canvas / Minimalism",
    year: 2023,
  },
  {
    id: "kompozycja-xvi",
    slug: "kompozycja-xvi",
    title: "Kompozycja XVI",
    image: "https://gonzaga.pl/img/16.jpg",
    category_pl: "Malarstwo sztalugowe",
    category_en: "Easel Painting",
    medium_pl: "Olej na płótnie / Minimalizm",
    medium_en: "Oil on canvas / Minimalism",
    year: 2024,
  },
];
